<template>
  <div>
    <div class="d-inline-flex align-items-center">
      <h4>Character</h4>
      <div class="ml-4">
        <div class="row form-group align-items-center">
          <div class="col-sm-12">
            <!-- <select
              placeholder="Character Selector"
              class="custom-select"
              v-model="mainCharacterIndex"
              @change="changeModelInspector"
            >
              <option>Character Selector</option>
              <option
                v-for="(item, key) in charData"
                :key="key"
                :value="key"
              >{{ (parseInt(key) + 1) + '. ' + item.name }}</option>
            </select> -->
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="fields-wrapper">
          <div class="row form-group align-items-center">
            <label for="charname" class="col-sm-4 col-form-label"
              >Character Selector</label
            >
            <div class="col-sm-8">
              <!-- <input type="text" class="form-control" id="charname" v-model="inputData.name"> -->
              <select
                placeholder="Character Selector"
                id="charname"
                class="custom-select"
                v-model="inputData.selectedModel"
                @change="changeSelectedModel($event)"
              >
                <!-- <option disabled selected="true" value="undefined" >Character Selector</option> -->
                <option
                  v-for="(model, key) in fbxModels"
                  :key="key"
                  :value="key"
                  >{{ model.name }}</option
                >
              </select>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="start_time" class="col-sm-4 col-form-label">
              Start Time
            </label>
            <div class="col-sm-8">
              <input
                type="number"
                class="form-control"
                id="start_time"
                v-model="inputData.startTime"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="end_time" class="col-sm-4 col-form-label">
              End Time
            </label>
            <div class="col-sm-8">
              <input
                type="number"
                class="form-control"
                id="end_time"
                v-model="inputData.endTime"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="presentation_duration" class="col-sm-5 col-form-label"
              >Presence Duration (sec)</label
            >
            <div class="col-sm-7">
              <input
                type="text"
                :style="
                  errorPresenceDuration && {
                    boxShadow: '0 0 0 0.2rem red'
                  }
                "
                class="form-control"
                readonly
                id="presentation_duration"
                v-model="inputData.presenceDuration"
              />
            </div>
          </div>
          <!-- <div class="row form-group align-items-center">
            <label for="baked_lighting" class="col-sm-4 col-form-label">
              Baked Lighting
            </label>
            <div class="col-sm-8">
              <input type="text" class="form-control" id="baked_lighting" v-model="inputData.bakedLighting">
            </div>
          </div>-->
          <div class="row form-group align-items-center">
            <label for="polygon_count" class="col-sm-4 col-form-label"
              >Polygon Count</label
            >
            <div class="col-sm-8">
              <input
                readonly
                type="text"
                class="form-control"
                id="polygon_count"
                v-model="inputData.polygonCount"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label class="col-sm-4 col-form-label">Position of Origin</label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  type="number"
                  class="form-control border-danger"
                  id="position_of_the_origin_x"
                  step="0.01"
                  v-model="inputData.positionOfOrigin.x"
                />
                <span class="p-2">y</span>
                <input
                  type="number"
                  class="form-control  border-success"
                  id="position_of_the_origin_y"
                  step="0.01"
                  v-model="inputData.positionOfOrigin.y"
                />
                <span class="p-2">z</span>
                <input
                  type="number"
                  class="form-control border-secondary border-2"
                  id="position_of_the_origin_z"
                  step="0.01"
                  v-model="inputData.positionOfOrigin.z"
                />
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label class="col-sm-4 col-form-label">Rotation of Origin</label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  type="number"
                  class="form-control"
                  id="rotation_of_the_origin_x"
                  step="0.01"
                  v-model="inputData.rotationOfOrigin.x"
                />
                <span class="p-2">y</span>
                <input
                  type="number"
                  class="form-control"
                  id="rotation_of_the_origin_y"
                  step="0.01"
                  v-model="inputData.rotationOfOrigin.y"
                />
                <span class="p-2">z</span>
                <input
                  type="number"
                  class="form-control"
                  id="rotation_of_the_origin_z"
                  step="0.01"
                  v-model="inputData.rotationOfOrigin.z"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="fields-wrapper">
          <div class="row form-group align-items-center">
            <label class="col-sm-6 col-form-label">Scale (in meters)</label>
            <div class="col-sm-6">
              <div class="row align-items-center">
                <div class="col-8">
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    v-model="inputData.scale"
                  />
                  <input
                    type="number"
                    class="form-control"
                    step="0.01"
                    max="1"
                    min="0"
                    v-model="inputData.scale"
                  />
                </div>
                <span class="col-4">{{ inputData.scale }}</span>
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label class="col-sm-6 col-form-label">Dimensions (meters)</label>
            <div class="col-sm-6">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  id="dimensions_x"
                  v-model="inputData.dimensions.x"
                />
                <span class="p-2">y</span>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  id="dimensions_y"
                  v-model="inputData.dimensions.y"
                />
                <span class="p-2">z</span>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  id="dimensions_z"
                  v-model="inputData.dimensions.z"
                />
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="rig" class="col-sm-6 col-form-label">Rig Type</label>
            <div class="col-sm-6">
              <select
                id="rig"
                class="custom-select"
                readonly
                v-model="inputData.rigType"
              >
                <option value="Humanoid">Humanoid</option>
                <option value="Custom">Custom</option>
              </select>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="materials" class="col-sm-6 col-form-label">
              Materials
              <i class="fas fa-times text-danger ml-2"></i>
            </label>
            <div class="col-sm-6">
              <select
                id="materials"
                class="custom-select"
                v-model="inputData.material"
              >
                <option>Select Material</option>
                <option>Link 1</option>
                <option>Link 2</option>
                <option>Link 3</option>
              </select>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="interactive_surfaces" class="col-sm-6 col-form-label">
              Interactive Surfaces
              <i class="fas fa-times text-danger ml-2"></i>
            </label>
            <div class="col-sm-6">
              <select
                id="interactive_surfaces"
                class="custom-select"
                v-model="inputData.interactiveSurface"
              >
                <option>Select Interactive Surfaces</option>
                <option>Link 1</option>
                <option>Link 2</option>
                <option>Link 3</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { db } from '../../../../../firebaseDB'
import { mapActions, mapGetters, mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import $ from 'jquery'

export default {
  components: {},
  props: ['selectedCharecter', 'charData', 'currentIndex'],
  data () {
    return {
      mainCharacterIndex: 0,
      errorPresenceDuration: false,
      releaseLock: true,
      isLoaded: false,
      activeCharacter: {},
      inputData: {
        elementType: 'Character',
        name: '',
        image: '',
        startTime: 0,
        endTime: 10,
        presenceDuration: '',
        bakedLighting: '',
        polygonCount: '',
        selectedModel: null,
        positionOfOrigin: {
          x: 0.0,
          y: 0.0,
          z: 0.0
        },
        rotationOfOrigin: {
          x: 0.0,
          y: 0.0,
          z: 0.0
        },
        scale: 1.0,
        dimensions: {
          x: 0.0,
          y: 0.0,
          z: 0.0
        },
        rigType: '',
        material: '',
        interactiveSurface: '',
        origin: {
          position: {
            x: 0,
            y: 0,
            z: 0
          },
          rotation: {
            x: 0,
            y: 0,
            z: 0
          }
        },
        objectId: Math.floor(Date.now() / 1000)
      },
      saveData: {
        character: {
          name: '',
          startTime: '',
          endTime: '',
          presenceDuration: '',
          bakedLighting: '',
          polygonCount: '',
          scale: 1,
          dimensions: [],
          rigType: '',
          material: '',
          interactiveSurface: '',
          origin: {
            position: [],
            rotation: []
          },
          characterElements: []
        }
      },
      selectedLogic: null,
    }
  },
  created () {
    this.listFBXModels()
  },

  methods: {
    saveToDB () {
      this.saveData.elementType = this.inputData.elementType
      this.saveData.character.name = this.inputData.name
      this.saveData.character.startTime = this.inputData.startTime
      this.saveData.character.endTime = this.inputData.endTime
      this.saveData.character.presenceDuration = this.inputData.presenceDuration
      this.saveData.character.bakedLighting = this.inputData.bakedLighting
      this.saveData.character.polygonCount = this.inputData.polygonCount
      this.saveData.character.origin.position[0] =
        this.inputData.positionOfOrigin.x || 0
      this.saveData.character.origin.position[1] =
        this.inputData.positionOfOrigin.y || 0
      this.saveData.character.origin.position[2] =
        this.inputData.positionOfOrigin.z || 0
      this.saveData.character.origin.rotation[0] =
        this.inputData.rotationOfOrigin.x || 0
      this.saveData.character.origin.rotation[1] =
        this.inputData.rotationOfOrigin.y || 0
      this.saveData.character.origin.rotation[2] =
        this.inputData.rotationOfOrigin.z || 0
      this.saveData.character.scale = this.inputData.scale || 1
      this.saveData.character.dimensions[0] = this.inputData.dimensions.x || 1
      this.saveData.character.dimensions[1] = this.inputData.dimensions.y || 2
      this.saveData.character.dimensions[2] = this.inputData.dimensions.z || 1
      this.saveData.character.rigType = this.inputData.rigType
      this.saveData.character.material = this.inputData.material
      this.saveData.character.interactiveSurface = this.inputData.interactiveSurface
      this.saveData.character.type = 'Character'
      this.saveData.character.objectId = this.inputData.objectId
      this.saveData.character.layer = 1
      this.saveData.successCallback = this.showSuccessToast
      this.saveData.errorCallback = this.showErrorToast
      for (const [key, value] of Object.entries(this.fbxModels)) {
        if (value.name === this.inputData.name) {
          this.saveData.character.objectDbHash = key
          this.saveData.character.AndroidAssetBundle =
            value.asset_bundle.Android.fileURL
          this.saveData.character.iOSAssetBundle =
            value.asset_bundle.iOS.fileURL
          this.saveData.character.webglAssetBundle = 
            value.asset_bundle.WebGL.fileURL
          break
        }
      }
      let _this = this
      let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
      tRef.once('value').then(snapshot => {
        let json = snapshot.val().json
        let selectedNodePosition = this.selectedLogic.nodePosition;
        for (const snapshotkey in json.mainStory.nodes[selectedNodePosition].nodeElements) {
          if (
            json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].hasOwnProperty(
              'character'
            ) &&
            json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character
              .objectId == this.inputData.objectId
          ) {
            if (
              json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character
                .characterElements
            ) {
              _this.saveData.character.characterElements = []
              for (const innerKey in json.mainStory.nodes[selectedNodePosition].nodeElements[
                snapshotkey
              ].character.characterElements) {
                _this.saveData.character.characterElements.push(
                  json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character
                    .characterElements[innerKey]
                )
              }
            }
          }
        }
        _this.$store.dispatch('saveInspector', this.saveData)
        _this.releaseLock = true
      })
    },
    showSuccessToast () {
      this.$toast('Main inspector data saved', {
        timeout: 3000,
        type: 'success',
        showCloseButtonOnHover: true
      })
    },
    showErrorToast () {
      this.$toast('Main inspector data failed', {
        timeout: 3000,
        type: 'error',
        showCloseButtonOnHover: true
      })
    },
    ...mapActions(['listFBXModels']),
    changeSelectedModel (event = null) {
      if (event) {
        let newCharacters = this.characters
        newCharacters = this.characters.map(char =>
          char.objectId === this.activeCharacter.objectId
            ? {
              ...char,
              objectDbHash: event.target.value,
              name: this.fbxModels[event.target.value].name,
              // scale: this.fbxModels[event.target.value].scale || 1,
              AndroidAssetBundle: this.fbxModels[event.target.value]
                  .asset_bundle.Android.fileURL,
              iOSAssetBundle: this.fbxModels[event.target.value].asset_bundle
                  .iOS.fileURL,
              webglAssetBundle: this.fbxModels[event.target.value].asset_bundle
                  .WebGL.fileURL,
              material: this.fbxModels[event.target.value].material,
              dimensions: [
                this.fbxModels[event.target.value].dimension.X || 0.0,
                this.fbxModels[event.target.value].dimension.Y || 0.0,
                this.fbxModels[event.target.value].dimension.Z || 0.0
              ]
            }
            : { ...char }
        )
        
        this.$store.dispatch('updateCharacters', [])
        this.$store.dispatch('updateCharacters', newCharacters)
        let newChar = newCharacters.filter( char => {
           return char.objectId === this.activeCharacter.objectId
        })[0]
      }
    },
    changeModelInspector () {
      // this.characters.map
      // this.mainCharacterIndex
      // this.$emit('setCharacterIndex', this.mainCharacterIndex)
      // this.$store.dispatch('changeObjectId', this.charData[this.mainCharacterIndex].objectId)
    },
    // assignCharProperties () {
    //   if ( this.inputData.selectedModel) {
    //     this.inputData.name = this.inputData.selectedModel.name
    //     this.inputData.image = this.inputData.selectedModel.image
    //     this.inputData.polygonCount = this.inputData.selectedModel.polygon_count
    //     this.inputData.scale = this.inputData.selectedModel.scale
    //     this.inputData.dimensions.x = this.inputData.selectedModel.dimension.X
    //     this.inputData.dimensions.y = this.inputData.selectedModel.dimension.Y
    //     this.inputData.dimensions.z = this.inputData.selectedModel.dimension.Z
    //     this.inputData.rigType = this.inputData.selectedModel.hasOwnProperty(
    //       'rig'
    //     )
    //       ? this.inputData.selectedModel.rig
    //       : this.inputData.selectedModel.rigType
    //     this.inputData.interactiveSurface = this.inputData.selectedModel.hasOwnProperty(
    //       'interactiveSurface'
    //     )
    //       ? this.inputData.selectedModel.interactiveSurface
    //       : ''
    //     this.inputData.presenceDuration = this.inputData.presenceDuration
    //       ? this.inputData.presenceDuration
    //       : this.inputData.endTime - this.inputData.startTime
    //     this.$store.dispatch('updateTimeLine', {
    //       ...this.$store.state.inspector,
    //       main: {
    //         ...this.$store.state.inspector.main,
    //         startTime: this.inputData.startTime,
    //         endTime: this.inputData.endTime,
    //         image: this.inputData.image,
    //         name: this.inputData.name,
    //         scale: this.inputData.scale,
    //       }
    //     })
    //   }
    // },
    assignCharData () {
      //   if (this.charData.length) {
      //     this.inputData.name = this.charData[this.currentIndex].name
      //     this.inputData.image = this.selectedCharecter.image
      //     this.inputData.presenceDuration = this.charData[this.currentIndex].hasOwnProperty('presenceDuration') ? this.charData[this.currentIndex].presenceDuration : 0
      //     this.inputData.bakedLighting = this.charData[this.currentIndex].hasOwnProperty('bakedLighting') ? this.charData[this.currentIndex].bakedLighting : ''
      //     this.inputData.positionOfOrigin.x = this.charData[this.currentIndex].hasOwnProperty('origin') ? this.charData[this.currentIndex].origin.position[0] : 0
      //     this.inputData.positionOfOrigin.y = this.charData[this.currentIndex].hasOwnProperty('origin') ? this.charData[this.currentIndex].origin.position[1] : 0
      //     this.inputData.positionOfOrigin.z = this.charData[this.currentIndex].hasOwnProperty('origin') ? this.charData[this.currentIndex].origin.position[2] : 0
      //     this.inputData.rotationOfOrigin.x = this.charData[this.currentIndex].hasOwnProperty('origin') ? this.charData[this.currentIndex].origin.rotation[0] : 0
      //     this.inputData.rotationOfOrigin.y = this.charData[this.currentIndex].hasOwnProperty('origin') ? this.charData[this.currentIndex].origin.rotation[1] : 0
      //     this.inputData.rotationOfOrigin.z = this.charData[this.currentIndex].hasOwnProperty('origin') ? this.charData[this.currentIndex].origin.rotation[2] : 0
      //     this.inputData.layer = this.charData[this.currentIndex].layer
      //     this.inputData.scale = this.charData[this.currentIndex].scale
      //     this.inputData.objectId = this.charData[this.currentIndex].hasOwnProperty('objectId') ? this.charData[this.currentIndex].objectId : Math.floor(Date.now() / 1000)
      //     setTimeout(() => {
      //       this.inputData.startTime = this.getStartTime
      //       this.inputData.endTime = this.getEndTime
      //       for (const [key, value] of Object.entries(this.fbxModels)) {
      //         if (value.name == this.charData[this.currentIndex].name) {
      //           this.inputData.selectedModel = value
      //           this.inputData.polygonCount = value.polygon_count
      //           this.inputData.dimensions.x = value.dimension.X
      //           this.inputData.dimensions.y = value.dimension.Y
      //           this.inputData.dimensions.z = value.dimension.Z
      //           this.inputData.rigType = this.charData[this.currentIndex].hasOwnProperty('rigType')
      //             ? this.charData[this.currentIndex].rigType
      //             : value.rig
      //           this.inputData.material = this.charData[this.currentIndex].hasOwnProperty('material')
      //             ? this.charData[this.currentIndex].material
      //             : value.hasOwnProperty('material')
      //               ? value.material
      //               : ''
      //           this.inputData.interactiveSurface = this.charData[this.currentIndex].hasOwnProperty(
      //             'interactiveSurface'
      //           )
      //             ? this.charData[this.currentIndex].interactiveSurface
      //             : value.hasOwnProperty('interactiveSurface')
      //               ? value.interactiveSurface
      //               : ''
      //           // this.$emit('sendSelectedCharData', value)
      //           break
      //         }
      //       }
      //       this.$store.dispatch('updateTimeLine', {
      //         ...this.$store.state.inspector,
      //         main: {
      //           ...this.$store.state.inspector.main,
      //           startTime: this.charData[this.currentIndex].startTime,
      //           endTime: this.charData[this.currentIndex].endTime,
      //           image: this.selectedCharecter.image,
      //           name: this.inputData.name
      //         }
      //       })
      //       this.$store.dispatch('changeObjectId', this.charData[this.currentIndex].objectId)
      //     }, 1000)
      //   } else {
      //     this.inputData.selectedModel = this.selectedCharecter
      //     this.inputData.startTime = this.getStartTime
      //     this.inputData.endTime = this.getEndTime
      //     this.inputData.image = this.selectedCharecter.image
      //     this.assignCharProperties()
      //   }
      //   this.$store.dispatch('updateTimeLine', {
      //     ...this.$store.state.inspector,
      //     main: {
      //       ...this.$store.state.inspector.main,
      //       startTime: this.inputData.startTime,
      //       endTime: this.inputData.endTime,
      //       image: this.selectedCharecter.image,
      //       name: this.inputData.name
      //     }
      //   })
      //   this.isLoaded = true
    },
    getActiveChar () {
      let found = false
      for (let i = 0; i < this.characters.length; i++) {
        const char = this.characters[i]
        if (char.active) {
          this.activeCharacter = char
          found = true
        }
      }
      if (!found && this.characters) {
        this.activeCharacter = this.characters[0]
      }
      // Checking if the field is diffent of the one in the activeCharacter
      // then affecting to it, otherwise there will be an infinite loop because of the inputData watcher
      if (this.activeCharacter) {
        this.inputData.objectId = this.activeCharacter.objectId
        this.inputData.name !== this.activeCharacter.name &&
          (this.inputData.name = this.activeCharacter.name)
          if(this.activeCharacter.type.toLowerCase() === 'character'){

        this.inputData.image !==
          (this.fbxModels && this.activeCharacter.objectDbHash &&
            this.fbxModels[this.activeCharacter.objectDbHash] && this.fbxModels[this.activeCharacter.objectDbHash].image.imageURL &&
            (this.inputData.image =
              this.fbxModels &&
              this.activeCharacter.objectDbHash && this.fbxModels[this.activeCharacter.objectDbHash] && this.fbxModels[this.activeCharacter.objectDbHash].image.imageURL))
        }else if(this.activeCharacter.type.toLowerCase() === 'object3d'){
          
        this.inputData.image !==
          (this.propModels && this.activeCharacter.objectDbHash &&
            this.propModels[this.activeCharacter.objectDbHash].image.imageURL &&
            (this.inputData.image =
              this.propModels && this.activeCharacter.objectDbHash &&
              this.propModels[this.activeCharacter.objectDbHash].image.imageURL))
        }
        this.inputData.startTime !== this.activeCharacter.startTime &&
          (this.inputData.startTime = this.activeCharacter.startTime)
        this.inputData.selectedModel !== this.activeCharacter.objectDbHash &&
          (this.inputData.selectedModel = this.activeCharacter.objectDbHash)
        this.inputData.endTime !== this.activeCharacter.endTime &&
          (this.inputData.endTime = this.activeCharacter.endTime)
        // this.inputData.presenceDuration = this.activeCharacter.endTime - this.activeCharacter.startTime
        this.inputData.bakedLighting !== this.activeCharacter.bakedLighting &&
          (this.inputData.bakedLighting = this.activeCharacter.bakedLighting)
        this.inputData.polygonCount !== this.activeCharacter.polygonCount &&
          (this.inputData.polygonCount = this.activeCharacter.polygonCount)
        this.inputData.positionOfOrigin.x !==
          this.activeCharacter.origin.position && this.activeCharacter.origin.position[0] &&
          (this.inputData.positionOfOrigin.x = this.activeCharacter.origin.position[0])
        this.inputData.positionOfOrigin.y !==
          this.activeCharacter.origin.position && this.activeCharacter.origin.position[1] &&
          (this.inputData.positionOfOrigin.y = this.activeCharacter.origin.position[1])
        this.inputData.positionOfOrigin.z !==
          this.activeCharacter.origin.position && this.activeCharacter.origin.position[2] &&
          (this.inputData.positionOfOrigin.z = this.activeCharacter.origin.position[2])
        this.inputData.rotationOfOrigin.x !==
          this.activeCharacter.origin.rotation && this.activeCharacter.origin.rotation[0] &&
          (this.inputData.rotationOfOrigin.x = this.activeCharacter.origin.rotation[0])
        this.inputData.rotationOfOrigin.y !==
          this.activeCharacter.origin.rotation && this.activeCharacter.origin.rotation[1] &&
          (this.inputData.rotationOfOrigin.y = this.activeCharacter.origin.rotation[1])
        this.inputData.rotationOfOrigin.z !==
          this.activeCharacter.origin.rotation && this.activeCharacter.origin.rotation[2] &&
          (this.inputData.rotationOfOrigin.z = this.activeCharacter.origin.rotation[2])
        this.inputData.scale !== this.activeCharacter.scale &&
          (this.inputData.scale = this.activeCharacter.scale)
        this.inputData.rigType !== this.activeCharacter.rigType &&
          (this.inputData.rigType = this.activeCharacter.rigType)
        this.inputData.material !== this.activeCharacter.material &&
          (this.inputData.material = this.activeCharacter.material)
        this.inputData.interactiveSurface !==
          this.activeCharacter.interactiveSurface &&
          (this.inputData.interactiveSurface = this.activeCharacter.interactiveSurface)
        
        this.isLoaded = true
      }
    },
    dispatchActiveChar (data) {
      let newCharacters = this.characters
      newCharacters = this.characters.map(char =>
        char.objectId === this.activeCharacter.objectId
          ? {
            ...char,
            startTime: data.startTime,
            endTime: data.endTime,
            presenceDuration: data.presenceDuration,
            scale: data.scale,
            rigType: data.rigType,
            material: data.material,
            origin: {
              position: [
                data.positionOfOrigin.x,
                data.positionOfOrigin.y,
                data.positionOfOrigin.z
              ],
              rotation: [
                data.rotationOfOrigin.x,
                data.rotationOfOrigin.y,
                data.rotationOfOrigin.z
              ]
            },
            interactiveSurface: data.interactiveSurface
          }
          : { ...char }
      )
      if (this.characters != newCharacters) {
        this.$store.dispatch('updateCharacters', [])
        this.$store.dispatch('updateCharacters', newCharacters)
      }
    }
  },
  mounted () {
    // this.mainCharacterIndex = this.currentIndex
    this.selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'));
    var newChars = []
    var val = this.characters
    for (let i = 0; i < val.length; i++) {
      const char = val[i]
      if (char.active) {
        this.activeCharacter = char
      }
    }
    // val = newChars
    // if (!val[0].hasOwnProperty('animation')) {
    //   for (let i = 0; i < val.length; i++) {
    //     const char = val[i]
    //     if (char.active) {
    //       this.activeCharacter = char
    //     }
    //     newChars.push({ ...char, animation: [] })
    //   }
    // }
    // if (!val[0].hasOwnProperty('movement')) {
    //   for (let i = 0; i < val.length; i++) {
    //     const char = val[i]
    //     if (char.active) {
    //       this.activeCharacter = char
    //     }
    //     newChars.push({ ...char, movement: [] })
    //   }
    // }
    // this.$store.dispatch('updateCharacters', newChars)
    this.getActiveChar()
  },
  watch: {
    characters (val) {
      this.isLoaded = false
      this.getActiveChar()
      // val.map(char => {
      //   if (char.objectId === this.inputData.objectId) {
      //     this.inputData.startTime = char.startTime
      //     this.inputData.endTime = char.endTime
      //     this.inputData.presenceDuration = char.endTime - char.startTime
      //   }
      // })
    },

    // getStartTime (value) {
    //   this.inputData.startTime = value
    //   this.$store.dispatch('updateTimeLine', {
    //     ...this.$store.state.inspector,
    //     main: {
    //       ...this.$store.state.inspector.main,
    //       startTime: value || 0
    //     }
    //   })
    // },
    // getEndTime (value) {
    //   this.inputData.endTime = value
    //   this.$store.dispatch('updateTimeLine', {
    //     ...this.$store.state.inspector,
    //     main: {
    //       ...this.$store.state.inspector.main,
    //       endTime: value || 0
    //     }
    //   })
    // },
    inputData: {
      handler: function (val, oldVal) {
        this.dispatchActiveChar(val)
        this.inputData.presenceDuration =
          parseInt(this.inputData.endTime) - parseInt(this.inputData.startTime)
        this.errorPresenceDuration = !!(
          parseInt(this.inputData.endTime) <= parseInt(this.inputData.startTime)
        )
        if (this.releaseLock && this.isLoaded) {
          this.releaseLock = false
          setTimeout(() => {
            // this.saveToDB()
          }, 3000)
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['characters', 'fbxModels', 'inspector']),
    ...mapGetters(['getStartTime', 'getEndTime', 'getCharacters']),
    name: {
      get: function () {
        return this.$store.state.inspector.main.name
      },
      set: function (newVal) {
        this.inputData = this.$store.state.inspector.main
        this.inputData.name = newVal
        this.$store.dispatch('saveInspector', this.inputData)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.border-2 {
    border-width:2px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/character/maininspector.vue